/**
 * Translate description: Table component for users
 */

import { Fragment, useState } from 'react';

import Box from '@mui/joy/Box';
import Table from '@mui/joy/Table';
import Sheet from '@mui/joy/Sheet';
import Checkbox from '@mui/joy/Checkbox';
import Typography from '@mui/joy/Typography';

import { useListContext } from '../provider/ListProvider';
import TableHeaderSort from './layout/TableHeaderSort';
import { Loading } from './loading';
import Pagination from './layout/Pagination';
import { useLanguageContext } from '../context/LanguageContext';
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/joy';
import { TooltipProbablyWithLink, TooltipWithLink } from './TooltipWithLink';
function TableHeader({ column, listContext }) {
  const { t } = useLanguageContext();
  let { sort, order, setSort, setOrder } = listContext;
  let { header_style, sortable, field, label, info, info_link } = column
  header_style = header_style || {}
  header_style = { padding: '12px 6px', ...header_style }
  return <th style={header_style}>
    <TableHeaderSort
      sort={sort}
      order={order}
      setSort={setSort}
      setOrder={setOrder}
      sortBy={field}
      sortable={sortable}
    >
      {t(label)}
      {
        info && <TooltipProbablyWithLink to={info_link} title={info}>
          <InfoIcon />
        </TooltipProbablyWithLink>
      }
    </TableHeaderSort>
  </th>
}
function TableElement({ row_data, column }) {
  return <td style={column.row_style}>
    {<column.Element row={row_data} />}
  </td>
}
export function makeTable(columns, aggregationColumns, total_label = "Total", key_column = 'id') {
  return () => {
    const listContext = useListContext()
    const { t } = useLanguageContext();
    let { data } = listContext;
    let headers = columns.map(column => <TableHeader info_link={column.info_link} info={column.info} key={column.field} column={column} listContext={listContext} />)
    const { loading, error, tableInfo } = listContext;
    const [selected, setSelected] = useState([]);
    const rows = data.map(row_data =>
      <tr key={row_data[key_column]} style={{ opacity: loading ? 0.5 : 1 }}>
        {/* <td style={{ textAlign: 'center', width: 120 }}>
          <Checkbox
            size="sm"
            checked={selected.includes(row_data.id)}
            color={selected.includes(row_data.id) ? 'primary' : undefined}
            onChange={(event) => {
              setSelected((ids) =>
                event.target.checked
                  ? ids.concat(row_data.id)
                  : ids.filter((itemId) => itemId !== row_data.id),
              );
            }}
            slotProps={{ checkbox: { sx: { textAlign: 'left' } } }}
            sx={{ verticalAlign: 'text-bottom' }}
          />
        </td> */}
        {columns.map(column => <TableElement key={column.field + "#" + row_data[key_column]} row_data={row_data} column={column} />)}
      </tr>
    )
    const renderFooter = () => {
      const setFieldAggregation = (field) => {
        return listContext?.totals?.[field];
      }
      return (
        <tfoot>
          <tr>
            <th scope="row">{t(total_label)}:</th>
            {columns.map((column, index) => index == 0 ? null : <td key={column.field} style={column.row_style}>
              {aggregationColumns?.includes(column.field) ? <Typography level="body-xs">{setFieldAggregation(column.field)}</Typography> : null}
            </td>)}
          </tr>
        </tfoot>
      );
    }
    return (
      <Fragment>
        {selected.length ? (
          <Box>
            Выбрано элементов: {selected.length}
          </Box>
        ) : (<></>)}
        <Sheet
          className="OrderTableContainer"
          variant="outlined"
          sx={{
            // display: { xs: 'none', sm: 'initial' },
            width: '100%',
            borderRadius: 'sm',
            flexShrink: 1,
            // overflow: 'auto',
            minHeight: 0,
            overflowX: 'auto',
          }}
          style={{ position: "relative" }}
        >
          {loading && <div style={{ position: "absolute", top: 'calc(50% + 23px)', left: '50%', transform: 'translate(-50%, -50%)', display: 'flex', alignItems: 'center', gap: '1rem', border: 'none', zIndex: 1 }}><Loading size="sm" />{tableInfo && <Typography level="body-md">{tableInfo}</Typography>}</div>}
          <Table
            aria-labelledby="tableTitle"
            stickyHeader
            hoverRow
            sx={{
              '--TableCell-headBackground': 'var(--joy-palette-background-level1)',
              '--Table-headerUnderlineThickness': '1px',
              '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
              '--TableCell-paddingY': '4px',
              '--TableCell-paddingX': '8px',
              width: 'auto',
              minWidth: '100%',
            }}
          >
            <thead>
              <tr>
                {/* <th style={{ width: 48, textAlign: 'center', padding: '12px 6px' }}>
                  <Checkbox
                    size="sm"
                    indeterminate={
                      selected.length > 0 && selected.length !== data?.length
                    }
                    checked={selected.length > 0 && selected.length === data?.length}
                    onChange={(event) => {
                      setSelected(
                        event.target.checked ? data?.map((row) => row.id) : [],
                      );
                    }}
                    color={
                      selected.length > 0 || selected.length === data?.length
                        ? 'primary'
                        : undefined
                    }
                    sx={{ verticalAlign: 'text-bottom' }}
                  />
                </th> */}
                {headers}
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {
                error ?
                  <tr><td colSpan={columns.length + 1}><Typography level="body-lg" color="danger" sx={{ textAlign: 'center' }}>{error}</Typography></td></tr> :
                  rows.length > 0 ?
                    rows :
                    <tr><td colSpan={columns.length + 1}><Typography level="body-lg" sx={{ textAlign: 'center' }}>{loading ? null : t('No data')}</Typography></td></tr>
              }
            </tbody>
            {aggregationColumns && aggregationColumns.length > 0 ? renderFooter() : null}
          </Table>
        </Sheet>
        <Pagination />
      </Fragment>
    );
  }

}